<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title v-if="!typeProp" class="mt-4 me-4">
        {{ $t($route.name) }}</v-toolbar-title
      >
      <div v-if="!isMobile && !isTablet" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="
          selected.length > 0 &&
          !isMobile &&
          type !== 'removedInvoices' &&
          $store.state.permissions &&
          $store.state.permissions.includes(
            'remove' + type[0].toUpperCase() + type.substring(1)
          )
        "
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
            {{$t('refresh')}}
          </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && type !== 'removedInvoices'"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="
          !isMobile &&
          !isTablet &&
          $route.name !== 'sellTaxPayer' &&
          $store.state.permissions &&
          $store.state.permissions.includes(type)
        "
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col
        class="px-2"
        :class="{ 'mb-4': !isMobile && !isTablet, 'mb-2': isMobile || isTablet }"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col v-show="!isMobile" class="pa-0" cols="12" md="12">
        <div class="d-flex align-center justify-space-between gap-2">
          <v-chip-group mandatory active-class="primary--text">
            <v-chip label outlined>
              {{ $t("sumNetAmount") }} :
              {{ $numberFormat(summary ? summary.amount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip label outlined>
              {{ $t("sumDiscount") }} :
              {{ $numberFormat(summary ? summary.discount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip label outlined>
              {{ $t("sumTax") }} : {{ $numberFormat(summary ? summary.tax : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip label outlined>
              {{ $t("sumClearAmount") }} :
              {{ $numberFormat(summary ? summary.net_amount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
          </v-chip-group>
          <div>
            <v-btn
              v-if="taxPayerSystem"
              color="secondary"
              outlined
              height="32"
              class="me-2"
              :loading="loading"
              @click="taxPayerConfirmation"
            >
              <span>
                {{
                  taxPayerSelectedItems && taxPayerSelectedItems.length != 0
                    ? "(" + taxPayerSelectedItems.length + ")"
                    : ""
                }}
                {{ $t("taxPayerSystem") }}
              </span>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-col cols="12" class="px-2">
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile" v-slot:item="{ item, index }">
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-green':
                    item.type == 'sell' || item.type == 'presale' ? true : false,
                  'mobile-td-list-border-red': item.type == 'purchase' ? true : false,
                  'mobile-td-list-border-primary':
                    item.type == 'returnSell' || item.type == 'returnPurchase'
                      ? true
                      : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-show="!item.taxpayer"
                          link
                          :disabled="item.lock ? true : false"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item link @click="print(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item link @click="fishPrint(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-paper-roll-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceRollprint')" />
                        </v-list-item>
                        <v-list-item v-if="type == 'sell'" link @click="invoiceSms(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('sendInvoiceSMS')" />
                        </v-list-item>
                        <v-list-item
                          v-if="item.entrepot"
                          link
                          @click="entrepotPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-warehouse</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
                        </v-list-item>
                        <v-list-item link @click="copyInvoice(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-content-copy</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceCopy')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/' + type + '/edit/' + item.uid"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission(type) && !item.tax_payer"
                          link
                          :disabled="item.lock ? true : false"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.customer ? item.customer.name : "" }} ({{ item.number }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("document-number") }} :
                    {{ item.doc_header ? item.doc_header.number : "" }} | {{ $t("id") }} :
                    {{ item.id }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("discount") }} :
                    {{ $numberFormat(item.discount ? item.discount : 0) }} |
                    {{ $t("tax") }} : {{ $numberFormat(item.tax ? item.tax : 0) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("date") }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-for="(integrate, index) in item.integrator"
                        :key="index"
                        color="green"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ $t("registerBy") }} : {{ $t(integrate.key) }} |
                          {{ $t("id") }} : {{ integrate.value }}
                          {{
                            integrate.number
                              ? " | " + $t("number") + ":" + integrate.number
                              : ""
                          }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-if="item.payed"
                        class="ms-1"
                        :color="
                          parseFloat(item.price.price) - parseFloat(item.payed.amount) > 0
                            ? 'red'
                            : 'green'
                        "
                        small
                        outlined
                      >
                        {{
                          parseFloat(item.price.price) - parseFloat(item.payed.amount) > 0
                            ? $t("remainPrice") +
                              " " +
                              $numberFormat(
                                parseFloat(item.price.price) -
                                  parseFloat(item.payed.amount)
                              )
                            : $t("payed")
                        }}
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(item.price ? item.price.NetPrice : 0) }}
                    {{ item.currency ? item.currency.symbol : "" }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.action="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-show="!item.tax_payer"
                link
                :disabled="item.lock ? true : false"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">
                    {{ item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <v-list-item
                v-show="type == 'sell' || type == 'presale'"
                link
                @click="editCategory(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('editCasher')" />
              </v-list-item>
              <v-list-item link @click="print(item)">
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item link @click="selectedPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-format-list-group</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print') + '(' + $t('new') + ')'" />
              </v-list-item>
              <v-list-item link @click="fishPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-paper-roll-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceRollprint')" />
              </v-list-item>
              <v-list-item
                v-if="
                  !documentPermmission && item.attachments && item.attachments.length > 0
                "
                link
                @click="openDocumentsDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-attachment</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('documents')" />
              </v-list-item>
              <v-list-item
                v-if="type == 'sell' || type == 'presale'"
                link
                @click="invoiceSms(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-message-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendInvoiceSMS')" />
              </v-list-item>
              <v-list-item v-if="item.entrepot" link @click="entrepotPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-warehouse</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-if="taxPayerSystem"
                link
                @click="taxPayerConfirmationVMenu(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-send</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('taxPayerSystem')" />
              </v-list-item>
              <v-list-item link @click="copyInvoice(item)">
                <v-list-item-icon>
                  <v-icon>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceCopy')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type + '/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                v-show="
                  item.tax_payer &&
                  item.tax_payer.taxid &&
                  item.tax_payer.status == 'done'
                "
                link
                :disabled="item.lock ? true : false"
                @click="editTaxInvoice(item)"
              >
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-note-edit-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendEditTaxInvoice')" />
              </v-list-item>
              <v-list-item
                v-show="
                  removePermission(type) &&
                  (!item.tax_payer || (item.tax_payer && item.tax_payer.taxid))
                "
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-close-circle-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('annulmentInvoice')" />
              </v-list-item>
              <v-list-item
                v-show="
                  removePermission(type) &&
                  (!item.tax_payer || (item.tax_payer && !item.tax_payer.taxid))
                "
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item)) + parseInt(from) }}
        </template>
        <template v-slot:item.invoice_id="{ item }">
          <v-card-text class="pa-0">
            <span class="text-body-2">
              {{ item.id ? "#" + item.id : $t("haveNot") }}
            </span>
            <br />
            <span class="text-caption text-disable secondary--text">
              {{ item.number ? item.number : $t("haveNot") }}
            </span>
          </v-card-text>
        </template>
        <!-- add customer -->
        <template v-slot:item.customer.name="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{
              item.customer
                ? [item.customer.firstname, item.customer.lastname]
                    .filter(Boolean)
                    .join(" ") || item.customer.name
                : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.invoice_type="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.type ? $t(item.type) : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.invoice_amount="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{
              item.price && item.price.price && item.currency
                ? $numberFormat(item.price.price, item.currency.decimal) +
                  " " +
                  item.currency.symbol
                : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.sent_type="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{
              item.tax_payer.state
                ? item.tax_payer.state == "new"
                  ? $t("main")
                  : item.tax_payer.state == "edit"
                  ? $t("edit-mode")
                  : item.tax_payer.state == "delete"
                  ? $t("delete-mode")
                  : $t("haveNot")
                : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.invoice_date="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.date ? item.date : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.unique_tax_number="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{
              item.tax_payer && item.tax_payer.taxid
                ? item.tax_payer.taxid
                : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.sent_date="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{
              item.tax_payer && item.tax_payer.created_at
                ? $moment(item.tax_payer.created_at).format("jYYYY/jMM/jDD")
                : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.system_status="{ item }">
          <v-chip
            v-if="
              item.tax_payer &&
              item.tax_payer.status != 'error' &&
              item.tax_payer.status != 'sent' &&
              item.tax_payer.status != 'done' &&
              item.tax_payer.status != 'editSent' &&
              item.tax_payer.status != 'removeSent'
            "
            small
            :color="resolveTaxPayerStatusColor(item.tax_payer)"
            @click="openTaxPayerStatus(item.tax_payer)"
          >
            {{ resolveTaxPayerStatus(item.tax_payer) }}
          </v-chip>
          <v-chip
            v-if="
              item.tax_payer &&
              (item.tax_payer.status == 'error' ||
                item.tax_payer.status == 'sent' ||
                item.tax_payer.status == 'done' ||
                item.tax_payer.status == 'editSent' ||
                item.tax_payer.status == 'removeSent')
            "
            small
            :color="
              item.tax_payer.status == 'error'
                ? 'error'
                : item.tax_payer.status == 'sent'
                ? 'primary'
                : item.tax_payer.status == 'done'
                ? 'success'
                : item.tax_payer.status == 'editSent'
                ? 'warning'
                : item.tax_payer.status == 'removeSent'
                ? 'error'
                : ''
            "
          >
            {{
              item.tax_payer.status == "error"
                ? $t("error-in-sending-invoice")
                : item.tax_payer.status == "sent"
                ? $t("shipped")
                : item.tax_payer.status == "done"
                ? $t("confirmed")
                : item.tax_payer.status == "editSent"
                ? $t("edited")
                : item.tax_payer.status == "removeSent"
                ? $t("cenceled")
                : $t("undefined")
            }}
          </v-chip>
        </template>
        <template v-slot:item.details="{ item }">
          <v-btn
            color="primary"
            text
            @click="getTaxPayerHistory(item)"
            :loading="loading"
          >
            {{ $t("show-details") }}
          </v-btn>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoicePrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="invoicePrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint :id-prop="printId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <status v-model="sellStatus" :hideconfig="true" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <v-select
              dense
              outlined
              :label="$t('system-status')"
              :items="systemStatusItems"
              v-model="systemStatus"
              height="32"
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="!isMobile && customFieldsPermission" class="mx-0">
          <custom-fields
            v-model="customFields"
            :value="customFields"
            type-prop="invoiceCustomFields"
            :multiple="true"
            class="px-4"
          />
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0 py-1">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 py-1">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="invoice"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="documentsDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <div align="center" class="px-4">
          <v-btn color="primary" block elevation="0" style="font-size: 16px">
            {{ documentsTitleDialog }}
          </v-btn>
        </div>
        <v-col class="mt-0 pt-0 pr-7">
          <file-picker
            ref="refFilePicker"
            :label="$t('addDocuments')"
            :multiple="false"
            :hide-remove="true"
            type-prop="invoice"
            :val="documents ? documents : null"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="groupPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="40%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="groupPrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="text-right">
            <v-radio-group v-model="printType">
              <v-radio value="officialInvoice">
                <template v-slot:label>
                  <div>{{ $t("officialInvoice") }}</div>
                </template>
              </v-radio>
              <v-radio value="invoice">
                <template v-slot:label>
                  <div>{{ $t("generalInvoice") }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn color="primary" :loading="loading" @click="groupPrintInvoice">
            {{ $t("print") }}
          </v-btn>
          <v-spacer />
          <v-btn color="grey" @click="groupPrintDialog = !groupPrintDialog">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--taxpayer show status dialog-->
    <v-dialog
      v-model="taxPayerStatusReviewDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="500"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{
              $t("errors-invoice") +
              (taxPayerStatusError ? taxPayerStatusError.head_id + "#" : "")
            }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerStatusReviewDialog = false">mdi-close</v-icon>
        </v-container>
        <v-data-table
          v-if="taxPayerStatusErrorItems"
          :headers="taxPayerStatusErrorHeaders"
          :items="taxPayerStatusErrorItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.systemErrors="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.code && item.message
                  ? "(" + item.code + ")" + " " + item.message
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!--show tax payer history-->
    <v-dialog
      v-model="taxPayerHistoryDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="550"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{ $t("system activities of this factor") }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerHistoryDialog = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 mt-5">
          {{ $t("history of this invoice when sent to the system") }}
        </v-card-text>
        <v-data-table
          :headers="taxPayerHistoryHeaders"
          :items="taxPayerHistoryItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.history="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ resolveTaxPayerHistoryStatus(item) }}
            </v-card-text>
          </template>
          <template v-slot:item.register_date="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.created_at ? item.created_at : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.action="{ item }">
            <v-card-text class="pa-0 text-caption">
              <v-btn
                :disabled="
                  item.response && !item.response.hasError && item.status_response == null
                "
                text
                @click="openTaxPayerHistoryErrors(item)"
                :loading="loading"
              >
                {{ $t("show-details") }}
              </v-btn>
            </v-card-text>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- taxpayer message -->
    <v-dialog
      v-model="taxPayerMsgDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="550"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{ $t("errors-invoice") }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerMsgDialog = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2">
          {{ $t("error") }} : {{ taxPayerStatusErrorItems }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--tax payer confirmation-->
    <v-dialog
      v-model="taxPayerConfirmDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="400"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">
            {{ $t("are you share you want to send these items to taxpayer system ?") }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerConfirmDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="primary" height="32" @click="sendToTaxPayer" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="taxPayerConfirmDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Task from "../task/task";
import Invoicprint from "./print";
import General from "../../../../Mixins/general";
import Upload from "../../components/general/upload/upload";
import filePicker from "../../components/general/filePicker/index";
import TaxPayerContent from "./taxPayerContent.vue";
import customFields from "../../components/general/customFields/index.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import moment from "moment-jalaali";

export default {
  name: "InvoiceList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    dialogComponent: () => import("../../components/general/dialog/index"),
    Upload,
    customFields,
    filePicker,
    TaxPayerContent,
    Invoicprint,
    Task,
    MyIcon,
  },
  mixins: [General],
  props: ["input", "refId", "typeProp", "accountProp", "mobileShow"],
  data: () => ({
    selected: [],
    printHeaders: [],
    datatableStore: false,
    summary: null,
    registerar: null,
    removedInvoices: null,
    groupPrintDialog: false,
    invoicePrintDialog: false,
    printDialog: false,
    deletDialog: false,
    uploadDialog: false,
    documentsDialog: false,
    documents: false,
    documentsTitleDialog: "",
    printType: "invoice",
    dialogData: null,
    entrepot: null,
    category: null,
    account: null,
    currencyFilter: null,
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    printId: null,
    showSelect: true,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    customFields: null,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    selectedHeadersTemp: [],
    headersMap: null,
    pageCount: 1,
    page: 1,
    excelItems: [],
    today: null,
    taxPayerStatusReviewDialog: false,
    taxPayerStatusError: null,
    taxPayerStatusErrorItems: null,
    taxPayerStatusErrorHeaders: null,
    taxPayerHistoryDialog: false,
    taxPayerHistoryItems: null,
    taxPayerHistoryHeaders: null,
    taxPayerMsgDialog: false,
    taxPayerSelectedItems: null,
    taxPayerConfirmDialog: false,
    systemStatus: null,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "sell") {
          if (s.value === "pre_invoice") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
    totals: function () {
      // var total = this.items.map(function (value, key) {
      //   app.remove(value, key)
      // })
      // var app = this
      // app.excelItems = []
      const totals = this.items.reduce(
        (acc, d) => {
          acc.price += d.price
            ? parseFloat(d.price.price) +
              parseFloat(d.discount ? d.discount : 0) -
              parseFloat(d.tax ? d.tax : 0)
            : 0;
          acc.sumNetAmount += d.price ? parseFloat(d.price.price) : 0;
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          return acc;
        },
        {
          sumNetAmount: 0,
          price: 0,
          discount: 0,
          tax: 0,
        }
      );
      return totals;
    },
    systemStatusItems() {
      return [
        { label: this.$t("pending-new"), value: "PENDING" },
        { label: this.$t("success-new"), value: "SUCCESS" },
        { label: this.$t("failed-new"), value: "FAILED" },
        // { label: this.$t('pending-edit'), value: '' },
        // { label: this.$t('success-edit'), value: '' },
        // { label: this.$t('failed-edit'), value: '' },
        // { label: this.$t('pending-delete'), value: '' },
        // { label: this.$t('success-delete'), value: '' },
        // { label: this.$t('failed-delete'), value: '' },
        // { label: this.$t('error-in-sending-invoice'), value: '' },
        // { label: this.$t('shipped'), value: '' },
        // { label: this.$t('confirmed'), value: '' },
        // { label: this.$t('edited'), value: '' },
        // { label: this.$t('cenceled'), value: '' }
      ];
    },
  },
  watch: {
    selectedHeaders(val) {},
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      // taxPayerSystem
      this.taxPayerSelectedItems = this.selected.filter(
        (item) => moment().diff(moment(item.date, "jYYYY/jMM/jDD"), "days") <= 30
      );

      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      app.getItems();
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    accountProp(val) {
      this.getItems();
    },
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    if (this.$route.name === "purchaseList") {
      this.type = "purchase";
    }
    if (this.$route.name === "presaleList") {
      this.type = "presale";
    }
    if (this.$route.name === "sellList" || this.$route.name === "taxPayerSellList") {
      this.type = "sell";
    }
    if (this.$route.name === "returnPurchaseList") {
      this.type = "returnPurchase";
    }
    if (this.$route.name === "returnSellList") {
      this.type = "returnSell";
    }
    if (this.$route.name === "sellTaxPayer") {
      this.type = "sell";
    }
    if (this.$route.name === "removedInvoices") {
      this.type = "removedInvoices";
      this.removedInvoices = "active";
    }
    if (this.typeProp) {
      this.type = this.typeProp;
    }
    this.headers = [
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
        width: 20,
      },
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("invoice-id"),
        sortable: true,
        value: "invoice_id",
      },
      //add customer//
      {
        text: this.$t("detailsInvoice"),
        sortable: false,
        value: "customer.name",
      },
      {
        text: this.$t("invoice-type"),
        sortable: true,
        value: "invoice_type",
      },

      {
        text: this.$t("invoice-amount"),
        sortable: true,
        value: "invoice_amount",
      },
      {
        text: this.$t("sent-type"),
        sortable: true,
        value: "sent_type",
      },
      {
        text: this.$t("invoice-date"),
        sortable: true,
        value: "invoice_date",
      },
      {
        text: this.$t("unique-tax-number"),
        sortable: true,
        value: "unique_tax_number",
      },
      {
        text: this.$t("sent-date"),
        sortable: true,
        value: "sent_date",
      },
      {
        text: this.$t("system-status"),
        sortable: true,
        value: "system_status",
      },
      {
        text: this.$t("details"),
        sortable: true,
        value: "details",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("number"),
        value: "number",
      },
      {
        text: this.$t("detailsName"),
        value: "customer.name",
      },
      {
        text: this.$t("mobile"),
        value: "customer.mobile",
      },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("NetAmount"),
        value: "price.NetPrice",
      },
      {
        text: this.$t("discount"),
        value: "discount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("tax"),
        value: "tax",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("finalAmount"),
        value: "price.price",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumPayments"),
        value: "payed.paymentsAmount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumChecks"),
        value: "payed.checksAmount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumPayed"),
        value: "payed.amount",
        sum: true,
        type: "number",
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    // this.headersMap = this.headers
    this.selectedHeaders = this.headers;
    this.taxPayerStatusErrorHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("system-errors"),
        align: "start",
        sortable: false,
        value: "systemErrors",
      },
    ];
    this.taxPayerHistoryHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("history"),
        align: "start",
        sortable: false,
        value: "history",
      },
      {
        text: this.$t("register-date"),
        align: "start",
        sortable: false,
        value: "register_date",
      },
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
      },
    ];
  },
  mounted() {
    this.setToday();
    this.getPermissions();
  },
  methods: {
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        this.today = `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        const tags = d.tags.map((item) => item.text).join(",");
        app.excelItems.push({
          id: d.id,
          type: app.$t(d.type),
          number: d.number,
          customer: d.customer ? d.customer.name : null,
          mobile: d.customer ? d.customer.mobile : null,
          date: d.date,
          price: app.$numberFormat(d.price ? d.price.price : 0),
          discount: app.$numberFormat(d.discount),
          tax: app.$numberFormat(d.tax),
          warehouse: d.entrepot ? d.entrepot.entrepot.name : "",
          payment: d.payed ? app.$numberFormat(d.payed.amount) : "",
          content: d.content,
          tags: d.tags ? tags : null,
          integrator:
            d.integrator && d.integrator.length > 0
              ? app.$t(d.integrator[0].key) +
                " = " +
                d.integrator[0].value +
                " | " +
                d.integrator[0].number
              : "",
          user: d.user ? d.user.name : "",
          status: d.tax_payer ? app.$t(d.tax_payer.status) : "",
          taxId: d.tax_payer ? d.tax_payer.taxid : "",
        });
      });
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    reviewDigikalaOrder() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            reviewDigikalaOrder: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            refreshRemovedInvoices: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openUploadDialog(item) {
      this.uploadDialog = true;
    },
    openDocumentsDialog(item) {
      this.documentsTitleDialog =
        this.$t("documents") + " " + this.$t(item.type) + " " + item.number;
      this.documents = item.attachments;
      this.documentsDialog = true;
    },
    copyInvoice(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice/" + item.uid + "/edit", {
          params: {
            id: item.uid,
          },
        })
        .then((res) => {
          res = res.data;
          app.$router.push({ name: app.type, params: { itemsProp: res.article } });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    entrepot_(item) {
      this.$router.push({ name: item.type + "Edit", params: { id: item.id } });
    },
    openComponent(component, id) {
      if (this.$store.state.permissions.includes("customerEdit")) {
        this.dialogData = {
          name: component,
          id: id,
        };
        this.innerComponent = true;
      }
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      if (!this.removedInvoices) {
        this.$router.push({
          name: this.type + "Edit",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    editCategory(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoiceCasherEdit",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    print(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoicePrint",
          params: { id: item.uid, tabName: item.number },
        });
      }
      // this.printId = item.uid
      // this.invoicePrintDialog = true
    },
    fishPrint(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoiceRollprint",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    entrepotPrint(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: item.entrepot.type + "Print",
          params: { id: item.entrepot.id },
        });
      }
    },
    getItems() {
      var app = this;
      app.filter = false;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "invoice", {
            params: {
              search: app.search,
              accountProp: app.accountProp ? app.accountProp.id : null,
              account: app.account,
              fromDate: app.fromDate,
              toDate: app.toDate,
              fromAmount: app.fromAmount,
              category: app.category,
              toAmount: app.toAmount,
              fromNumber: app.fromNumber,
              toNumber: app.toNumber,
              currency: app.currencyFilter,
              entrepot: app.entrepot,
              branch: app.branch,
              page: app.allRows ? app.excelPage : app.options.page,
              refId: app.refId,
              type: app.type,
              sortBy: app.sortBy,
              customFields: app.customFields,
              status: app.sellStatus,
              options: app.options,
              tag: app.tag,
              typeForm: app.typeForm,
              registerar: app.registerar,
              lockStatus: app.lockStatus,
              removedInvoices: app.removedInvoices,
              taxpayer: app.$route.name === "sellTaxPayer" ? "active" : null,
              taxpayerStatus: app.systemStatus,
            },
          })
          .then((res) => {
            res = res.data;
            if (!app.allRows) {
              app.items = res.data;
              app.totalItems = res.total;
              app.pageCount = res.last_page;
              app.from = res.from;
              app.summary = res.summary;
              app.creatExcelData(res.data);
              app.selected = [];
            } else {
              app.generateExcellForAllData(res.data, res.last_page);
            }
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.loading = false));
      }, 500);
    },
    invoiceSms(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            invoiceSMS: "active",
            id: item.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarColor = "green";
          app.snakbarText = this.$t("sent");
          app.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    sendTaxInvoice(type = null) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            sendTaxInvoice: "active",
            type: type,
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          if (!type) {
            app.snakbarColor = "green";
            app.snakbarText = this.$t("sent");
            app.snakbar = true;
          } else {
            app.getItems();
          }
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    editTaxInvoice(item) {
      var app = this;
      app.loading = true;
      var selected = [item.id];
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            editTaxInvoice: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          // if (!type) {
          //   app.snakbarColor = 'green'
          //   app.snakbarText = this.$t('sent')
          //   app.snakbar = true
          // } else {
          app.getItems();
          // }
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    selectedPrint(item) {
      this.selected = [item];
      this.groupPrintDialog = true;
    },
    groupPrintInvoice() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            groupPrint: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.$router.push({
            name: "reportViewer",
            params: { dataProp: res, reportProp: app.printType },
          });
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "invoice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(function () {
          app.deleteItem = null;
          app.loading = false;
        });
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            deleteItems: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(function () {
          app.deleteItem = null;
          app.selected = [];
          app.loading = false;
        });
    },
    getPermissions() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getPermissions",
          },
        })
        .then((res) => {
          res = res.data;
          app.$store.commit("SET_PERMISSIONS", res.permissions);
        });
    },
    resolveTaxPayerStatus(item) {
      if (item.state) {
        // new
        if (item.state == "new") {
          if (item.status == "PENDING") {
            return this.$t("pending-new");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-new");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-new");
          }
        }
        // edit
        if (item.state == "edit") {
          if (item.status == "PENDING") {
            return this.$t("pending-edit");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-edit");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-edit");
          }
        }
        // delete
        if (item.state == "delete") {
          if (item.status == "PENDING") {
            return this.$t("pending-delete");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-delete");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-delete");
          }
        }
      }
    },
    resolveTaxPayerStatusColor(item) {
      if (item.state) {
        // new
        if (item.state == "new" || item.state == "edit" || item.state == "delete") {
          if (item.status == "PENDING") {
            return "primary";
          }
          if (item.status == "SUCCESS") {
            return "success";
          }
          if (item.status == "FAILED") {
            return "error";
          }
        }
      }
    },
    openTaxPayerStatus(item) {
      if (item.state) {
        if (item.state == "new" || item.state == "edit" || item.state == "delete") {
          if (item.status == "FAILED") {
            this.taxPayerStatusError = item;
            this.taxPayerStatusErrorItems = JSON.parse(item.reponse).data[0].error;
            if (this.taxPayerStatusErrorItems) {
              this.taxPayerStatusReviewDialog = true;
            }
          }
        }
      }
    },
    getTaxPayerHistory(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$apipoint + "v2/tax-payer/get-logs", {
          params: {
            invoice_id: item.id,
          },
        })
        .then((r) => {
          this.taxPayerHistoryItems = r.data.data;
          if (this.taxPayerHistoryItems && this.taxPayerHistoryItems.length > 0) {
            this.taxPayerHistoryDialog = true;
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
        });
    },
    resolveTaxPayerHistoryStatus(item) {
      if (item.status == "PENDING") {
        return this.$t("send to tax payer system");
      }
      if (item.status == "SUCCESS") {
        return this.$t("submited in tax payer system");
      }
      if (item.status == "FAILED") {
        return this.$t("error in sending invoice");
      }
    },
    openTaxPayerHistoryErrors(item) {
      if (
        item.response != null &&
        !item.response.hasError &&
        item.status_response != null &&
        item.status_response[0][0].status == "FAILED"
      ) {
        this.taxPayerStatusReviewDialog = true;
        this.taxPayerStatusErrorItems = item.status_response[0][0].data.error;
      }
      if (
        item.response != null &&
        item.response.hasError &&
        item.status_response == null
      ) {
        this.taxPayerStatusReviewDialog = true;
        this.taxPayerStatusErrorItems = item.response.data[0].error;
      }
      if (item.response == null) {
        this.taxPayerMsgDialog = true;
        if (item.message != null) {
          this.taxPayerStatusErrorItems = item.message;
        } else {
          this.taxPayerStatusErrorItems = this.$t("Unknown error");
        }
      }
    },
    taxPayerConfirmationVMenu(item) {
      this.selected.push(item);
      var app = this;
      setTimeout(function () {
        app.taxPayerConfirmation();
      }, 500);
    },
    taxPayerConfirmation() {
      if (this.taxPayerSelectedItems && this.taxPayerSelectedItems.length > 0) {
        this.taxPayerConfirmDialog = true;
      } else {
        this.snakbar = true;
        this.snakbarText = this.$t("time-is-up");
        this.snakbarColor = "red";
      }
    },
    sendToTaxPayer() {
      var app = this;
      app.loading = true;
      app.$axios
        .post(this.$apipoint + "v2/" + "tax-payer/send", {
          items: this.taxPayerSelectedItems.map((item) => item.id),
        })
        .then((r) => {
          this.invoiceErrorItems = r.data
            .filter((item) => item.hasError == true)
            .map((item) => ({
              invoice: item.invoice,
              data: item.data,
            }));

          if (this.invoiceErrorItems && this.invoiceErrorItems.length > 0) {
            this.taxPayerConfirmDialog = false;
            this.invoiceErrorDialog = true;
          } else {
            this.taxPayerConfirmDialog = false;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  justify-content: inherit;
  min-width: unset;
}
::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 48px;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-data-table.checkAverage .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.checkAverage {
  border: 1px solid silver;
  /*  border-bottom: 0;
     border-bottom-right-radius: 0;
     border-bottom-left-radius: 0; */
  /* height: 300px;
    overflow-y: auto; */
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table {
    height: 100%;
  } */
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  background-color: #eeeeee;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-data-table.checkAverage.errors > .v-data-table__wrapper > table > tbody > tr {
  background-color: #fff0f3;
}
::v-deep
  .v-data-table.checkAverage.errors
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover {
  background-color: #fff0f3;
}
</style>
